import classNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import "./style.scss";

export interface Props {
  backgroundColor: string;
  children: ReactNode;
  isRotated?: boolean;
  size: "s" | "m" | "l";
}

const Tag: FunctionComponent<Props> = ({ backgroundColor, children, isRotated = false, size }) => {
  return (
    <div
      className={classNames(`Tag Tag--size-${size}`, {
        "Tag--rotated": isRotated,
      })}
      style={{ backgroundColor }}
    >
      {children}
    </div>
  );
};

export default Tag;
